import React, { Suspense, useCallback } from 'react';
import Scene from './Scene';
import Environment from './Environment';
import ThreeConvaiClient from './ThreeConvaiClient';
import CharactersContainer from './CharactersContainer';
import { Canvas } from '@react-three/fiber';
import { SIMULATION_TYPES } from '../../constants/simulationConstants';
import { useSimulationContext } from '../../providers/SimulationProvider';

/**
 * `client` is passed in for the Nudgyt Agent simulations: its hook has to live
 * outside this Canvas (see ThreeNudgytAgentClient), because react-three-fiber
 * only re-renders its tree while the canvas measures larger than 0x0 — which
 * stops as soon as the parent app hides the avatar.
 */
function ThreeCanvas({ client }) {
  const { isClientInitialized, simulationType } = useSimulationContext();

  console.debug('[DEBUG] ThreeCanvas rendered', {
    isClientInitialized,
    simulationType
  });

  const renderClient = useCallback(() => {
    if (client) return <CharactersContainer client={client} />;
    if (simulationType === SIMULATION_TYPES.BASIC) return <ThreeConvaiClient />;
    return null;
  }, [client, simulationType]);

  return (
    <Canvas className={`${isClientInitialized ? 'opacity-100' : 'opacity-0'}`}>
      <Suspense>
        <group>
          <Scene />
          <Environment />
          {renderClient()}
        </group>
      </Suspense>
    </Canvas>
  );
}

export default ThreeCanvas;
